// @ts-nocheck

import { find } from 'lodash';
import memoize from 'memoize-state';

import { selectEntitiesBetslips } from '../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';
import { selectNetwork } from '../../selectors/network/networkPrimary.selector';
import { selectUserConnected } from '../../selectors/user/userPrimary.selector';
import { BetslipStatus } from '../../types/history';
import { NetworkStatuses } from '../../types/network';

/*
 * Return an array with all possible betslips references, specifically for cashout
 * ex: from cashout betslipReference 2QCX0-3TOPQEH6-4
 * return [2QCX0-3TOPQEH6-4, 2QCX0-3TOPQEH6-3, 2QCX0-3TOPQEH6-2, 2QCX0-3TOPQEH6-1]
 */
export const getCashoutRelatedReference = (betslipReference) => {
  if (!betslipReference) {
    return [];
  }

  const refs = [betslipReference];
  const parts = betslipReference.split('-');
  if (parts.length === 3) {
    // is a cashout reference ex: 2QCX0-3TOPQEH6-2
    let decrement = parseInt(parts[2], 10) - 1;
    while (decrement >= 1) {
      refs.push(`${parts[0]}-${parts[1]}-${decrement}`);
      decrement--;
    }
  }
  return refs;
};

export const getBetslipFromReference = (betslips, betslipReference) =>
  find(betslips, (betslip) => betslip.betslipReference === betslipReference);

export const legacyHistoryItemDetailPropsSelector = memoize((state, { betslipReference }) => {
  const betslips = selectEntitiesBetslips(state);
  const connected = selectUserConnected(state);
  const networkStatus = selectNetwork(state);
  const canFetch = connected && networkStatus === NetworkStatuses.CONNECTED;

  const betslipReferencesToFetch = [];
  let stopRelatedBetDisplay = false;
  let betslipIds = [];

  const betslipReferences = getCashoutRelatedReference(betslipReference);

  betslipIds = betslipReferences.reduce((acc, cur, index) => {
    const betslip = getBetslipFromReference(betslips, cur);
    // if betslip is undefined, we want the component to fetch the missing reference
    if (betslip === undefined) {
      betslipReferencesToFetch.push(cur);
      return acc;
    }

    const { status, betslipId } = betslip;
    // for cashout, if we find a splited bet or another running bet we stop bets display here
    if ((index !== 0 && status === BetslipStatus.RUNNING) || status === BetslipStatus.SPLITED) {
      stopRelatedBetDisplay = true;
    }
    const returnValue = !stopRelatedBetDisplay ? [...acc, betslipId] : acc;
    // if first requested bet is a cashout we don't want other bets
    if (index === 0 && status === BetslipStatus.CASHOUT) {
      stopRelatedBetDisplay = true;
    }
    return returnValue;
  }, []);

  return {
    connected,
    betslipIds,
    betslipReferencesToFetch,
    canFetch,
  };
});

export default legacyHistoryItemDetailPropsSelector;
